(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/hooks/use-live-data.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/hooks/use-live-data.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

const getLiveTableId = svs.components.casino.formatGame.getLiveTableId;
const _svs$components$casin = svs.components.casino_react.casinoStore.endpoints.searchApi,
  useGetSocketLiveDataQuery = _svs$components$casin.useGetSocketLiveDataQuery,
  useGetSocketJackpotDataQuery = _svs$components$casin.useGetSocketJackpotDataQuery;
const interpretLiveData = svs.components.casino.game.interpretLiveData;
const interpretJackpotData = jackpot => {
  if (!jackpot) {
    return;
  }
  return _objectSpread(_objectSpread({}, jackpot), {}, {
    amount: Math.round(jackpot.amount / 100)
  });
};
const hasLiveOrJackpotData = gameModel => {
  const collection = {
    jackpotId: null,
    liveTableId: null,
    clientStartType: gameModel === null || gameModel === void 0 ? void 0 : gameModel.clientStartType,
    shouldSkip: false
  };
  if (!(gameModel !== null && gameModel !== void 0 && gameModel.clientStartType)) {
    collection.shouldSkip = true;
    return collection;
  }
  collection.clientStartType = gameModel.clientStartType.charAt(0).toUpperCase() + gameModel.clientStartType.slice(1).toLowerCase();
  if (gameModel.lobbyType === 'live') {
    collection.liveTableId = gameModel.provider === 'Playtech' ? gameModel.liveTableId : getLiveTableId(gameModel, gameModel.provider);
  }
  if (gameModel.jackpotId) {
    collection.jackpotId = gameModel.jackpotId;
  }
  return collection;
};
const useLiveData = gameModel => {
  const _hasLiveOrJackpotData = hasLiveOrJackpotData(gameModel),
    jackpotId = _hasLiveOrJackpotData.jackpotId,
    liveTableId = _hasLiveOrJackpotData.liveTableId,
    clientStartType = _hasLiveOrJackpotData.clientStartType,
    shouldSkip = _hasLiveOrJackpotData.shouldSkip;
  const _useGetSocketLiveData = useGetSocketLiveDataQuery({
      liveTableId,
      clientStartType,
      provider: gameModel === null || gameModel === void 0 ? void 0 : gameModel.provider
    }, {
      skip: shouldSkip || !liveTableId
    }),
    liveData = _useGetSocketLiveData.data;
  const _useGetSocketJackpotD = useGetSocketJackpotDataQuery({
      jackpotId,
      clientStartType
    }, {
      skip: shouldSkip || !jackpotId
    }),
    jackpotData = _useGetSocketJackpotD.data;
  const useCloudCasinoApis = svs.core.detect.feature('ft-use-casino-cloud-apis');
  if (!useCloudCasinoApis) {
    return {
      liveData: liveData !== null && liveData !== void 0 && liveData.game ? interpretLiveData(liveData.game) : undefined,
      jackpotData: jackpotData !== null && jackpotData !== void 0 && jackpotData.jackpot ? jackpotData.jackpot : undefined
    };
  }
  return {
    liveData: liveData ? liveData : undefined,
    jackpotData: jackpotData ? interpretJackpotData(jackpotData) : undefined
  };
};
setGlobal('svs.components.casino_react.casino_store.hooks.useLiveData', useLiveData);

 })(window);